/**
 * Confirmación del impacto masivo.
 *
 * §9 y Fase 8: el operador ve y confirma el conjunto **exacto**, con lo que
 * se va a registrar en cada jornada. Nunca se impacta "todo lo que matchee el
 * filtro" — por eso el diálogo lista las filas una por una.
 */

import type { JornadaDto } from '../../api';
import { Modal } from '../../components/Modal';
import { aDdMmAaaa } from '../../lib/fechas';
import { SalidaAMarcar } from './SalidaAMarcar';

export interface PropsDialogo {
  readonly abierto: boolean;
  readonly jornadas: readonly JornadaDto[];
  readonly onCancelar: () => void;
  readonly onConfirmar: () => void;
}

export function DialogoMasivo({
  abierto,
  jornadas,
  onCancelar,
  onConfirmar,
}: PropsDialogo): React.JSX.Element {
  return (
    <Modal
      abierto={abierto}
      titulo="Confirmar el impacto"
      onCerrar={onCancelar}
      ancho="amplio"
      pie={
        <>
          <button type="button" className="plano" onClick={onCancelar}>
            Cancelar
          </button>
          <button type="button" onClick={onConfirmar}>
            Procesar
          </button>
        </>
      }
    >
      <p>
        {`Se van a registrar las licencias y marcar la salida al fin de turno de ${String(jornadas.length)} jornada(s) en GeoVictoria. Revisá el conjunto exacto:`}
      </p>

      <div className="tabla-envoltorio dialogo-lista">
        <table className="tabla">
          <thead>
            <tr>
              <th scope="col">Dni</th>
              <th scope="col">Nombre</th>
              <th scope="col" className="num">Fecha</th>
              <th scope="col" className="num">Salida a marcar</th>
              <th scope="col">A registrar</th>
            </tr>
          </thead>
          <tbody>
            {jornadas.map((j) => (
              <tr key={`${j.dni}|${j.fechaOperativa}`}>
                <td className="num">{j.dni}</td>
                <td className="truncado">{j.nombre ?? '—'}</td>
                <td className="num">{aDdMmAaaa(j.fechaOperativa)}</td>
                <td className="num">
                  <SalidaAMarcar jornada={j} />
                </td>
                <td className="truncado">{j.etiquetasAcciones.join(' + ')}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Modal>
  );
}
